import * as d3 from 'd3';
import debounce from './utils/debounce'

drawChart();
window.addEventListener("resize", debounce(drawChart, 300));

function drawChart() {
  d3.selectAll('svg').remove();

  var maximumHeight = 300;

  var margin = {top: 30, right: 30, bottom: 30, left: 60};

  d3.selectAll('.chart').each(function (d, i) {
    var thisEl = d3.select(this);

    const sizing = thisEl.node().parentNode.getBoundingClientRect();

    var width = sizing.width - margin.left - margin.right;
    var height = (width > maximumHeight ? maximumHeight : width) - margin.top - margin.bottom;

    var county = d3.select(this).attr('data-county');
    // pulls the json url from the variable set in index.html
    var jsonURL = window.COUNTY_JSON[county];
    var countyChart = '.' + county + '-chart';

    var x = d3.scaleLinear().range([0, width]);
    var y = d3.scaleLinear().range([height, 0]);

    var bisectDate = d3.bisector(function (d) { return d.day; }).left;
    var commaFormat = d3.format(',');

    var xAxis = d3.axisBottom()
          .scale(x)
          .ticks(12)
          .tickFormat(d3.format('d'));

    var yAxis = d3.axisLeft()
          .scale(y)
          .ticks(6)
          .tickSize(-width)
          .tickFormat(commaFormat);

    var dataline = d3.line()
          .x(function (d) { return x(d.day); })
          .y(function (d) { return y(d.cumulative_in_person); });

    var svg = d3.select(countyChart)
        .append('svg')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .style('overflow', 'visible')
        .append('g')
            .attr('transform',
                  'translate(' + margin.left + ',' + margin.top + ')');

    d3.json(jsonURL, function (error, data) {
      if (error) throw error;
      // Scale the range of the data
      x.domain(d3.extent(data, function (d) { return d.day; })).nice();
      // takes highest cumulative in person totals and rounds to
      // the nearest hundred thousand to even out the charts
      y.domain([0, d3.max(data, function (d) {  return  (Math.ceil((d.cumulative_in_person)/50000)*50000); })]).nice();
      // y.domain([0, d3.max(data, function (d) { console.log(d.county, d.cumulative_in_person); return d.cumulative_in_person; })]).nice();

        // Add the X Axis
      svg.append('g')
          .attr('class', 'x axis')
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis)
          .append('text')
          .attr('x', -18)
          .attr('y', 18)
          .attr('class', 'x-label')
          .style('text-anchor', 'middle')
          .text('Day');

        // Add the Y Axis
      var yTicks = svg.append('g')
            .attr('class', 'y axis')
            .call(yAxis);

      // creates new object for each year
      var dataNest = d3.nest()
            .key(function (d) { return d.year; })
            .entries(data);

      var years = svg.selectAll('.year')
        .data(dataNest)
        .enter().append('g')
        .attr('class', 'year');

      // adds a line for each year
      years.append('path')
        .attr('class', function (d) { return 'line line' + d.key; })
        .attr('d', function (d) { return dataline(d.values); });

      var firstYTick = yTicks.select('.tick:first-of-type');
      firstYTick.select('text').text('');

      var lastYTick = yTicks.select('.tick:last-of-type');

      // text and position for y axis label
      var title = lastYTick.append('text')
        .attr('x', 63)
        .attr('dy', '.32em')
        .text('early voters');

      lastYTick.select('line')
        .attr('x1', title.node().getBBox().width + 6);

      // sets up dynamic HTML for tooltip
      var tooltip = thisEl.select('.tooltip').style('display', 'none');
      var tooltipDay = tooltip.select('.tooltip__day');
      var tooltipYears = {
        2016: tooltip.select('.tooltip__2016'),
        2012: tooltip.select('.tooltip__2012'),
        2008: tooltip.select('.tooltip__2008')
      };

      // append a circle for each year to go along with the tooltip
      var circle2008 = svg.append('circle')
          .attr('r', 4)
          .attr('class', 'circle2008')
          .style('display', 'none');
      var circle2012 = svg.append('circle')
          .attr('r', 4)
          .attr('class', 'circle2012')
          .style('display', 'none');
      var circle2016 = svg.append('circle')
          .attr('r', 4)
          .attr('class', 'circle2016')
          .style('display', 'none');

      // adds overlay to each chart for tooltip to float over
      // set up mouseover functionality
      svg.append('rect')
            .attr('class', 'overlay')
            .attr('width', width)
            .attr('height', height)
            .on('mouseover', function (d) {
              tooltip.style('display', null);
              circle2008.style('display', null);
              circle2012.style('display', null);
              circle2016.style('display', null);
            })
            .on('mouseout', function () {
              tooltip.style('display', 'none');
              circle2008.style('display', 'none');
              circle2012.style('display', 'none');
              circle2016.style('display', 'none');
            })
            .on('mousemove', mousemove);

      // Mouseover functionality for tooltip
      function mousemove () {
        // magic telling tooltip where to go based on where your mouse is
        var x0 = x.invert(d3.mouse(this)[0]);
        var i = x0 >= 14 ? 15 : bisectDate(dataNest[0].values, x0, 1);
        var d0 = data[i - 1];
        var d1 = data[i];
        var d = x0 - d0.day > d1.day - x0 ? d1 : d0;
        // creating datanest to parse out years for tooltip
        var output = dataNest.map(function (year) {
          // prevents it from being super mad if there isn't data for a particular day
          if (year.values.length < d.day) {
            return {year: year.key, cumulative_in_person: null};
          } else {
            return year.values[d.day - 1];
          }
        });
        // empty array to collect cumulative in person counts
        // so the tooltip can be positioned at highest y value
        // for each day
        var highestCount = [];
        // loops through values of each year to plug data into tooltip
        output.forEach(function (year) {
          // pushes cumulative in person numbers to empty array
          highestCount.push(year.cumulative_in_person);
          // sets text for tooltip
          tooltipYears[year.year].text(`${year.year}: ${(year.cumulative_in_person ? commaFormat(year.cumulative_in_person) : '-')}`);
          // positions circles for each line
          svg.select('.circle' + year.year).attr('transform', 'translate(' + x(d.day) + ',' + y(year.cumulative_in_person) + ')');
          // if there isn't data for a day, hide the circle
          if(year.cumulative_in_person === null) {
            svg.select('.circle' + year.year).style('display', 'none');
          } else {
            svg.select('.circle' + year.year).style('display', null);
          }
        });
        // sorts the array of cumulative in person values, smallest to largest
        highestCount.sort(function(a, b) {
          return a - b;
        });

        // finds largest cumulative in person number
        var yPosition;
        if(highestCount[2] === null) {
          yPosition = highestCount[1];
        } else {
          yPosition = highestCount[2];
        }
        tooltipDay.text(`Day ${d.day}`);
        tooltip.style('left', `${x(d.day)}px`);
        // positions tooltip at highest y value for each day
        tooltip.style('top', `${y(yPosition) - 80}px`);
      }
    });
  });
}



/** WEBPACK FOOTER **
 ** ./chart.js
 **/